import { Component } from 'react';

export default (WrappedComponent, defaultTab) => (
  class extends Component {
    constructor(props) {
      super(props);
      const {location} = this.props;

      let tab = location.hash;
      if (!tab) {
        tab = defaultTab;
      } else {
        tab = tab.substr(1);
      }

      this.state = {tab};
    }


    handleTabSelect = (tab) => {
      this.setState({tab});
    };

    render() {
      return <WrappedComponent tab={this.state.tab} handleTabSelect={this.handleTabSelect} {...this.props} />;
    }
  }
);
